import Image from 'next/image';
import { ServerMediaAsset } from '@/lib/janitsjar/Product';

type SceneryImageProps = {
  media: ServerMediaAsset;
};

export default function SceneryImage({ media }: SceneryImageProps) {
  return (
    <div className="relative w-full h-full overflow-hidden">
      <Image
        src={media.url}
        alt="Carousel image"
        fill
        className="object-contain"
      />
    </div>
  );
}
